
/** check if the app is being ran in JsDom (test environment) */
export const isRunningInJsDom =  () => {
    return navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom")
};